// dayjs-setup.ts
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/el';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localeData from 'dayjs/plugin/localeData';
import minMax from 'dayjs/plugin/minMax';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(duration);
dayjs.extend(minMax);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isoWeek);

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale('en-gb');

// IMPORTANT: utc first, then timezone
dayjs.extend(utc);
dayjs.extend(timezone);

// The default zone is the signed-in user's profile zone, set by utils/dates/displayTimezone.ts.

// Greek needs the genitive month after a day ("29 Οκτωβρίου 2026"), the nominative on its own ("Οκτώβριος 2026").
const EL_MONTHS_STANDALONE =
  'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
    '_'
  );
const EL_MONTHS_FORMAT =
  'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
    '_'
  );
const MONTH_AFTER_DAY = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;

const elMonths = Object.assign(
  (instance: Dayjs, format: string) =>
    (MONTH_AFTER_DAY.test(format) ? EL_MONTHS_FORMAT : EL_MONTHS_STANDALONE)[instance.month()],
  { s: EL_MONTHS_STANDALONE, f: EL_MONTHS_FORMAT }
);
// dayjs's locale typings only allow a months array, but its formatter and plugins accept this form (as in the ru locale).
(dayjs.Ls.el as unknown as { months: unknown }).months = elMonths;

export default dayjs;
